import { createUseStyles } from 'react-jss';

import { ICON_COLOR, ICON_BACKGROUND, ICON_FILL } from '../../../data';

export default createUseStyles<string, ICON_COLOR>(
  {
    root: {
      borderRadius: 32,
      display: 'inline-block',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '16px',
      padding: [8, 16],
      backgroundColor: (color) => ICON_BACKGROUND[color],
      color: (color) => ICON_FILL[color],
    },
  },
  {
    name: 'Tag',
  },
);
